module.exports = __webpack_public_path__ + "static/media/polo.53f3ed1e.jpg";